export default {
    path : "enterprise-integral",
    name : "enterprise-integral",
    meta : {
        title : "企业积分"
    },
    component: () => import('@/pages/enterprise/integral/Index'),
    redirect: {
        name : "enterprise-integral-water"
    },
    children: [
        {
            path: 'water',
            name: 'enterprise-integral-water',
            meta: {
                title: '积分流水'
            },
            component: () => import('@/pages/enterprise/integral/business/Integral'),
        },
    ]
}



// WEBPACK FOOTER //
// ./src/router/enterprise/integral_enterprise/index.js